import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import FastCashPresenter from '../../../../../../presenters/FastCashPresenter';
import UserPresenter from '../../../../../../presenters/UserPresenter';
import CheckInPresenter from '../../../../../../presenters/FastCash/CheckInPresenter';
import Row from '../../../../../../components/Row';
import Value from '../../../../../../components/Value';
import Group from '../../../../../../components/Group';
import appRoutes from '../../../../../../routes/appRoutes';

import CheckIns from './components/CheckIns';

const FastCashInfo = (props) => {
  const { fastCash, checkIns, user } = props;
  const fastCashId = FastCashPresenter.id(fastCash);

  return (
    <div>
      <Group title="General Info">
        <Row>
          <Value attr="userEmail" title="User email">
            {UserPresenter.email(user)}
          </Value>
          <Value attr="membershipInfo" title="Membership Info">
            {FastCashPresenter.latestMembershipStateReadableWithSlash(fastCash)}
            <a
              className="action-button"
              href={appRoutes.membershipsPath(fastCashId)}
            >
              See history
            </a>
          </Value>
        </Row>
        <Row>
          <Value attr="firstOnboardedAt" title="First Onboarded At">
            {FastCashPresenter.firstOnboardedAtReadable(fastCash)}
          </Value>
          <Value attr="pendingCash" title="Pending Cash">
            {FastCashPresenter.pendingCash(fastCash) || 0.0}
          </Value>
          <Value attr="availableCash" title="Available Cash">
            {FastCashPresenter.availableCash(fastCash) || 0.0}
          </Value>
          <Value attr="lifetimeCash" title="Lifetime Cash">
            {FastCashPresenter.lifetimeCash(fastCash) || 0.0}
          </Value>
        </Row>
      </Group>
      <Group title="Check-ins">
        {isEmpty(checkIns) ? (
          <div>The user has no check-ins for the period</div>
        ) : (
          <CheckIns checkIns={checkIns} />
        )}
      </Group>
    </div>
  );
};

export default FastCashInfo;

FastCashInfo.propTypes = {
  fastCash: FastCashPresenter.shape().isRequired,
  checkIns: PropTypes.arrayOf(CheckInPresenter.shape()),
  user: UserPresenter.shape().isRequired,
};
